<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.range-slider {
    padding: 0;
    width: 100%;

    .range-slider-rail,
    .range-slider-fill {
        height: 20px;
        border-radius: 10px;
    }

    .range-slider-knob {
        width: 35px;
        height: 35px;
        box-shadow: 1px 1px rgba(0, 0, 0, 0.3);
    }

    .range-slider-fill {
        background-color: @brand-primary;
    }

    &.--danger .range-slider-fill {
        background-color: @brand-danger;
    }
    &.--success .range-slider-fill {
        background-color: @brand-success;
    }
}
</style>

<script type="text/babel">
import 'vue-range-slider/dist/vue-range-slider.css'

import VueRangeSlider from 'vue-range-slider/dist/vue-range-slider'

export default {
    mixins: [VueRangeSlider],
}
</script>
